// Angular
import { ModuleWithProviders } from '@angular/core';
import { Routes } from '@angular/router';
// Module components
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
// Auth
import { AuthGuard, AuthService, CashierGuard, LoginGuard, AdminGuard, ModuleGuard } from '../../../core/auth';
var ɵ0 = { returnUrl: window.location.pathname };
var routes = [
    {
        path: '',
        component: AuthComponent,
        canActivate: [LoginGuard],
        children: [
            {
                path: '',
                redirectTo: 'login',
                pathMatch: 'full',
            },
            {
                path: 'login',
                component: LoginComponent,
                data: ɵ0,
            },
            {
                path: 'register',
                component: RegisterComponent,
            },
            {
                path: 'forgot-password',
                component: ForgotPasswordComponent,
            }
        ]
    }
];
var AuthModule = /** @class */ (function () {
    function AuthModule() {
    }
    AuthModule.forRoot = function () {
        return {
            ngModule: AuthModule,
            providers: [
                AuthService,
                AuthGuard,
                CashierGuard,
                LoginGuard,
                AdminGuard,
                ModuleGuard
            ]
        };
    };
    return AuthModule;
}());
export { AuthModule };
export { ɵ0 };
